/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import styles from './LoginForm.module.scss'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import {  Form, Button, Input, Divider } from 'antd'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { showToast, handleLoginSuccess, getCtCookie, setLoginCookie } from 'src/core/helpers'
import { CustomTextInput, CustomCheckBox, CustomTitle } from 'src/components'
import { loginAuthSelector, loginUser, resetLoginState, userAuthenticatedState } from 'src/features'

const LoginForm: React.FC = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const router = useRouter()
  const { redirect } = router.query
  const [rememberMe, setRememberMe] = useState(false)
  const [credentials, setCredentials] = useState(null)
  const user = useAppSelector(userAuthenticatedState)

  const {
    loading: loadingLogin,
    success: successLogin,
    error: errorLogin
  } = useAppSelector(loginAuthSelector)

  useEffect(() => {
    if (!credentials) { setCredentials(localStorage?.getItem('credentials')) }
  }, [])

  useEffect(() => {
    if (credentials) {
      form.setFieldsValue({ ['email']: JSON.parse(credentials)?.email })
      setRememberMe(true)
    }
  }, [credentials])

  useEffect(() => {
    if (successLogin) {
      dispatch(resetLoginState())
      handleLoginSuccess(rememberMe, form, router, redirect, user)
    }
  }, [successLogin])

  useEffect(() => {
    if (errorLogin) {
      showToast('error', errorLogin, 4)
      dispatch(resetLoginState())
    }
  }, [errorLogin])


  const onFinish = (values: { email: string, password: string }) => {
    const ct_vid_cookie = getCtCookie('ct_vid')
    const payload = { ...values, language: i18n.language, visitor_id: ct_vid_cookie }
    setLoginCookie()
    dispatch(loginUser(payload))
  }

  return <Form
    name='basic'
    onFinish={onFinish}
    autoComplete='off'
    form={form}
  >
    {/* Email */}
    <CustomTitle label={t('admin.Brokerage.Email')} className='label-input'/>
    <CustomTextInput
      name={'email'}
      placeholder={t('admin.Brokerage.EmailPlaceHolder')}
      type='email'
      required
    />

    {/* Password */}
    <CustomTitle label={t('admin.Brokerage.Password')} />
    <Form.Item
      name={'password'}
      rules={[{ required: true, message: t('general.RequiredValidation'), whitespace: true }]}
    >
      <Input.Password
        placeholder={t('admin.Brokerage.PasswordPlaceHolder')}
        size='large'
      />
    </Form.Item>

    {/* Remember me checkbox */}
    <CustomCheckBox
      defaultValue={rememberMe}
      handleChange={(value: boolean) => setRememberMe(value)}
      text={t('Auth.Login.RememberMe')}
    />

    {/* Forgot Pasword */}
    <Button
      type='link'
      className={styles.linkBtn}
      onClick={() => router.push('/auth/forgot-password')}
    >{t('settings.ForgotPassword')}
    </Button>

    <Divider className={styles.divider} />

    {/* Submit Button */}
    <div className='is-align-content-center'>
      <Button
        htmlType='submit'
        loading={loadingLogin}
        type='primary'
        size='large'
        className='radius-100'
        block
      >{loadingLogin ? t('Auth.Login.LoggingIn') : t('Auth.Login.Login')}
      </Button>
    </div>
  </Form>
}

export default LoginForm
